export interface DownloadCardProps {
  label?: string;
  url?: string;
  target?: string;
}

enum DownloadCardIconName {
  FILE_DOWNLOAD = 'file-download',
}

export { DownloadCardIconName };
